import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Wordmark } from "./Logo";

const cols = [
  {
    heading: "Services",
    links: [
      { label: "AI Strategy & Consulting", href: "/services/ai-strategy-consulting" },
      { label: "AI Implementation", href: "/services/custom-ai-implementation" },
      { label: "Custom Development", href: "/services/custom-development" },
      { label: "Digital Transformation", href: "/services/digital-transformation" },
      { label: "High-ROI Marketing", href: "/services/high-roi-marketing" },
    ],
  },
  {
    heading: "Results",
    links: [
      { label: "Results", href: "/#results" },
      { label: "Case Studies", href: "/case-studies" },
    ],
  },
  {
    heading: "About",
    links: [
      { label: "About Us", href: "/about" },
      { label: "Our Process", href: "/process" },
      { label: "Contact Us", href: "/contact" },
    ],
  },
];

export const Footer = () => (
  <footer
    data-testid="footer-section"
    className="relative bg-[#0B0F19] grain border-t border-white/10 pt-16 lg:pt-20 pb-10 overflow-hidden"
  >
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
        <div className="md:col-span-5">
          <div data-testid="footer-logo-mark">
            <Wordmark dark />
          </div>
          <p className="mt-6 text-slate-400 text-base leading-relaxed max-w-sm">
            AI strategy, implementation, development, digital transformation
            and high-ROI marketing — engineered for measurable enterprise
            outcomes.
          </p>
        </div>
        {cols.map((col) => (
          <div key={col.heading} className="md:col-span-2">
            <p className="font-mono-tech text-[11px] uppercase tracking-[0.25em] text-slate-500 mb-5">
              {col.heading}
            </p>
            <ul className="space-y-3">
              {col.links.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="text-sm text-slate-300 hover:text-white transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
        <div className="md:col-span-3">
          <p className="font-mono-tech text-[11px] uppercase tracking-[0.25em] text-slate-500 mb-5">
            Start a conversation
          </p>
          <a
            href="mailto:hello@mayforward.com"
            className="group inline-flex items-center gap-2 text-base font-semibold text-white hover:text-teal-400 transition-colors"
            data-testid="footer-email-link"
          >
            hello@mayforward.com
            <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>
      </div>
      <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-slate-500">
          © {new Date().getFullYear()} May Forward Tech. All rights reserved.
        </p>
        <p className="font-mono-tech text-[11px] uppercase tracking-[0.25em] text-slate-600">
          Architecting enterprise AI & digital evolution
        </p>
        <a
          href="/admin"
          data-testid="footer-admin-login"
          className="text-sm text-slate-500 hover:text-slate-300 transition-colors"
        >
          Admin login
        </a>
      </div>
    </div>
  </footer>
);
